import {Directive, ElementRef, HostListener, Optional} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[appUppercase]'
})
export class UppercaseDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() private ngControl: NgControl
  ) {}

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;
    const original = input.value;
    const uppercased = original.toUpperCase();

    if (uppercased === original) return;

    const selectionStart = input.selectionStart ?? uppercased.length;
    const selectionEnd = input.selectionEnd ?? selectionStart;

    input.value = uppercased;
    this.ngControl?.control?.setValue(uppercased, {emitEvent: false});
    input.setSelectionRange(selectionStart, selectionEnd);
  }
}
